<template>
  <li class="checkout-overlay-combo-item-holder">
    <div class="checkout-overlay-combo-item" :class="[type, {selected}]">
      <slot />
    </div>
  </li>
</template>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .checkout-overlay-combo-item-holder {
    height: 54px;
    display: flex;
    flex-direction: row;
  }

  .checkout-overlay-combo-item {
    position: relative;
    color: #fff;
    font-size: 13px;
    text-transform: uppercase;
    padding: 10px 18px;
    cursor: pointer;
    flex: 1;
    text-align: left;
    background-color: #03212b;
    display: flex;
    align-items: center;

    &:hover {
      opacity: .6;
    }

    &:before {
      content: '';
      width: 18px;
      height: 18px;
      border: 2px #fff solid;
      border-radius: 50%;
      position: absolute;
      top: 0;
      right: 18px;
      bottom: 0;
      margin: auto;
    }

    &:after {
      content: '';
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: $color-blue;
      position: absolute;
      top: 0;
      right: 24px;
      bottom: 0;
      margin: auto;
      opacity: 0;
      transition: opacity .3s $transition-ease-in-out;
    }

    &.selected {
      &:after {
        opacity: 1;
      }
    }

    &.clean {
      padding: 0;

      &:before,
      &:after {
        content: none;
      }
    }
  }

  .platform {
    .checkout-overlay-combo-item-holder {
      height: 30px;
    }

    .checkout-overlay-combo-item {
      background: #fff;
      color: #4a4a4a;

      &:before {
        border-color: #4a4a4a;
      }

      &:after {
        background-color: $color-main;
      }
    }
  }
</style>

<script>
  export default {
    name: 'checkout-overlay-combo-item',
    props: {
      selected: {
        type: Boolean,
        default: false
      },
      type: String
    }
  }
</script>
